var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.index % 2 === 1)?_c('odd-bg',{staticClass:"q-summit-row__top-bg",attrs:{"index":_vm.index}}):(_vm.index % 2 === 0)?_c('even-bg',{staticClass:"q-summit-row__top-bg",attrs:{"index":_vm.index}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }